<template>
  <div
    id="hostlist"
    class="bg-white px-3"
    style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important"
  >
    <!-- 表格 -->
    <div class="mt-3 pt-2">
      <el-table
        :data="tableData"
        @sort-change="sortChange"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed
          align="center"
          type="index"
          label="排序"
          width="50"
        />
        <el-table-column
          align="center"
          prop="client" 
          label="端"
        />
        <el-table-column
          align="center"
          prop="client_channel" 
          label="渠道号"
        />
         <el-table-column
          align="center"
          prop="create_time" 
          label="创建时间"
        />
        <el-table-column
          align="center"
          prop="create_time" 
          label="content"
        >
        <template slot-scope="v">
            <span class="ontt" @click="csontent(v.row.content)">{{v.row.content}}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="status" 
          label="状态"
        >
        <template slot-scope="v">
            <span v-if="v.row.status == 0">未处理</span>
            <span v-if="v.row.status == 1">已处理</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="v">
            <el-button v-if="v.row.status == 0" @click="Modifystateof(v.row.id)" type="primary" plain>修改状态</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      </el-table>
    </div>

    <div style="height: 60px"></div>
    <el-footer
      class="d-flex border-top bg-white align-items-center px-0 position-fixed"
      style="bottom: 0; left: 200px; right: 0; z-index: 100"
    >
      <!-- 底部 -->

      <div style="flex: 1" class="px-2">
        <el-pagination
          :current-page="page.current"
          :page-sizes="page.sizes"
          :page-size="page.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        >
        </el-pagination>
      </div>
    </el-footer>

    <el-dialog
    title="content"
    :visible.sync="consshow"
    width="40%">
        <p>{{contenttitle}}</p>
    </el-dialog>
  </div>
</template>

<script>
import common from "@/common/mixins/common.js";
export default {
  inject: ["layout"],
  mixins: [common],
  data() {
    return {
      editIndex: -1,
      //搜索数据
      from: {
        id: "",
        u_id: "",
        username: "",
        type: -1,
        time: [],
      },
      model_title: "Host",
      auth_val: "Mtlog",
      preUrl: "data/errorList", //列表地址

      tableData: [],
      form: {
        id: 0,
        remark: "",
      },
      prop: "",
      sort: "descending",
      rule_list: [],
      check_img_list: [],
      cz_money: 0,
      tx_money: 0,
      consshow: false,
      contenttitle: "",
    };
  },
  watch: {
    activeName(e) {
      console.log(e);
    },
  },
  created() {
    //this.commonList('rule');
  },
  methods: {
    sortChange(column) {
      this.prop = column.prop;
      this.sort = column.order;
      this.getList();
    },
    sortChangetwo(column) {
      this.proptwo = column.prop;
      this.sorttwo = column.order;
      this.lisktget();
    },
    //提交
    submit() {
      this.$refs.form.validate((res) => {
        if (res) {
          //this.form.default = this.form.default.replace(/\n/g,',')
          this.form.id = this.editIndex;
          this.addOrEdit(this.form);
          // 关闭模态框
        }
      });
    },
    csontent(data) {
      if (data) {
        this.contenttitle = data;
        this.consshow = true;
      }
    },
    Modifystateof(id) {
      this.$confirm("是否将状态修改为已处理？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.stateof(id);
        })
        .catch(() => {});
    },
    stateof(id) {
      //   修改状态
      if (id) {
        this.api
          .post(
            "/data/editErrorStatus",
            {
              id: id,
            },
            
          )
          .then((res) => {
            console.log(res);
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.getList();
          })
          .catch((err) => {});
      }
    },
    getListResult(e) {
      const data = e.list;
      for (let i in data) {
        if (data[i].create_time) {
          // 时间戳转换
          data[i].create_time = new Date(parseInt(data[i].create_time) * 1000)
            .toLocaleString()
            .replace(/:\d{1,2}$/, " ");
        }
      }
      this.tableData = data;
    },
    // 清空筛选条件
    clearSearch() {
      this.from = {
        id: "",
        u_id: "",
        username: "",
        type: -1,
        time: [],
      };

      this.search = "";
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.ontt {
  display: inline-block;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
